import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Logger } from './chatbot-logger.service'
import { IMessage, IMessageFrom, IdOptions, IWelcomeMessage, IPayloadToWatson } from './interfaces'
import { ChatMachineStatesEnum, ChatMachineEventEnum, ChatMachineEvent } from './interfaces-livechat'

@Injectable({
  providedIn: 'root'
})
export class MessageBus {

  private msgSubject = new Subject();

  private statusSubject = new Subject();

  private machineStateSubject = new Subject();

  constructor() { }

  /*
  PRO MESSAGES Z CHATU
  */

  publishMessageToBus(message: IMessage) {
    Logger.info(`BUS: New message published on the bus : ${JSON.stringify(message)}`)
    this.msgSubject.next(message);
  }

  clearMessages() {
    //TBD this.msgSubject.next();
  }

  getMessage(): Observable<any> {
    Logger.info(`BUS: Subscriber is getting message from the bus`)
    return this.msgSubject.asObservable();
  }

  /*
  PRO STATUS CHATU
  PRo globalni status (bot/chat) z FSM kvuli update UI
  */

  publishMachineEventToBus(status: ChatMachineEventEnum) {
    Logger.info(`BUS: New status published on the the bus : ${status}`)
    this.statusSubject.next(status);
  }


  clearStatuses() {
    //TBD this.statusSubject.next();
  }



  getMachineEventFromBus(): Observable<any> {
    Logger.info(`BUS: Subscriber is getting status from the bus`)
    return this.statusSubject.asObservable();
  }

  /*
   PRO publikaci FSM state
   
   */

  publishMachineStateToBus(state: ChatMachineStatesEnum) {
    Logger.info(`BUS: New FSM state published on the the bus : ${state}`)
    this.machineStateSubject.next(state);
  }


  clearMachineStates() {
    //TBD this.machineStateSubject.c();
  }

  getMachineStateFromBus(): Observable<any> {
  //  Logger.info(`BUS: FSM state subscriber is getting state from the bus`)
    return this.machineStateSubject.asObservable();
  }


}
